export const TIME_BEFORE_DELIVERY_TIMEOUT = 1000;
